import { api } from "@/lib/api";
import { LoginCredentials, RegisterCredentials, AuthResponse, User } from "@/types/auth";

export const authService = {
    register: async (data: RegisterCredentials) => {
        const response = await api.post<AuthResponse>("/api/v1/auth/register", data);
        return response.data;
    },

    login: async (data: LoginCredentials) => {
        const response = await api.post<AuthResponse>("/api/v1/auth/login", data);
        return response.data;
    },

    logout: async () => {
        const response = await api.post<{ message: string }>("/api/v1/auth/logout");
        return response.data;
    },

    changePassword: async (currentPassword: string, newPassword: string) => {
        const response = await api.post<{ message: string }>(
            "/api/v1/auth/change-password",
            { current_password: currentPassword, new_password: newPassword }
        );
        return response.data;
    },

    getCurrentUser: async (options?: { skipAuthHeader?: boolean }) => {
        const response = await api.get<User>("/api/v1/auth/me", {
            skipAuthHeader: options?.skipAuthHeader,
        });
        return response.data;
    },
};
